import AreUSureModal from './are-u-sure-modal';

export default AreUSureModal;
